// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "./assets/css/" + chunkId + "-" + {"35":"b3aa8a6f1624fd1f2bb9","248":"ba80a322182c352c450a","989":"1a09c64f0b86dbd3ce6a"}[chunkId] + ".css";
};